import { render, staticRenderFns } from "./ShopifyRedirect.vue?vue&type=template&id=456cb27c"
import script from "./ShopifyRedirect.vue?vue&type=script&lang=js"
export * from "./ShopifyRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports